export default __webpack_public_path__ + "media/images/features/local_delivery/episode3/LP_02-6220176ca7acb9d746cdcc80bbc23a58.jpg";